// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__PGCqT","icon":"style_icon__3C7l-","title":"style_title__340Y7","message":"style_message__1OFO3"};